import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {topicListFetch, topicFollow, topicUnfollow} from '../../../actions/index';
import {gtmSend} from '../../../helpers';
import { translate } from 'react-i18next';
import cx from '../../../styles';

class TopicActionButton extends Component {

    constructor(props) {
        super(props);
        this.state = {isMember: 0};
    }

    componentDidMount() {
        this.setState({isMember: this.props.topic.member});
    }

    topicFollowHandler = () => {
        if(!this.props.userReducer.id) {
            gtmSend('login_popup_open', 'Login Popup', 'Open', `${this.props.match? `Follow Topic || ${this.props.topic.name} || ${this.props.match.path}` : '--'}`, 0, {action: 'Open'});
        }
        gtmSend('click follow button', 'topic', 'follow', this.props.topic.name);
        this.props.topicFollow(this.props.topic.id)
        .then(()=>{
            if(this.props.userReducer.id) this.setState({isMember: 1});
            // if(this.props.shouldRefreshTopicList) this.props.topicListFetch();
        });
    }

    topicUnfollowHandler = () => {
        gtmSend('click follow button', 'topic', 'unfollow', this.props.topic.name);
        this.props.topicUnfollow(this.props.topic.id)
        .then(()=>{
            if(this.props.userReducer.id) this.setState({isMember: 0});
            // if(this.props.shouldRefreshTopicList) this.props.topicListFetch();
        });
    }

    render() {
        const {t} = this.props;

        return (
            <React.Fragment>
                {
                    typeof this.props.buttonType != undefined && this.props.buttonType == "plus"
                    ?
                        !this.state.isMember
                        ?
                            <button className={cx("btn-plus")} onClick={this.topicFollowHandler} aria-label="follow button"></button>
                            :
                            <button className={cx("btn-minus")} onClick={this.topicUnfollowHandler} aria-label="unfollow button"></button>
                    :
                        !this.state.isMember
                        ?
                            <React.Fragment>
                                <button className={cx("btn-plus")} onClick={this.topicFollowHandler} aria-label="follow button"></button>
                                <button className={cx("btn", "btn-primary", "hide")} onClick={this.topicFollowHandler}>{t('topic_follow')}</button>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <button className={cx("btn-minus")} onClick={this.topicUnfollowHandler} aria-label="unfollow button"></button>
                                <button className={cx("btn", "btn-border", "hide")} onClick={this.topicUnfollowHandler}>{t('topic_unfollow')}</button>
                            </React.Fragment>
                }

            </React.Fragment>
        );
    }


}

//map state
const mapStateToProps = (state) => {
    return state;
}

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        topicListFetch,
        topicFollow,
        topicUnfollow
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TopicActionButton));
